import { Platform } from "react-native";
import { Actor, Kind } from "@oui/lib/src/types";
export function isChatKind(kind) {
    return kind < 100 && kind !== Kind.NULL;
}
export function isInputKind(kind) {
    return kind >= 100 && kind < 200;
}
export function isSideEffectKind(kind) {
    return kind >= 400 && kind < 500;
}
export function isChatEnvelope(envelope) {
    return isChatKind(envelope.kind);
}
export function isInputEnvelope(envelope) {
    return isInputKind(envelope.kind);
}
export function isSideEffectEnvelope(envelope) {
    return isSideEffectKind(envelope.kind);
}
export function getEnvelopeDuration(envelope, isScreenReaderEnabled) {
    if (Platform.OS === 'web' && global.e2e) return 500;
    if (envelope.history) return 0;
    if (envelope.from === Actor.User) return 750;
    if (envelope.kind === Kind.ChatText) {
        var text = envelope.props.text.join('');
        return Math.min(Math.ceil(text.length / 25) * 750, 5000) * (isScreenReaderEnabled ? 2.5 : 1);
    } else if (isChatKind(envelope.kind)) {
        return 750;
    }
    return 0;
}
